module.exports = __webpack_public_path__ + "static/media/29BDOS26.f5faa38b.jpg";